import { Component, OnInit, Input } from '@angular/core';
import { PersonDTO } from '../../../../shared/person-dto';

@Component({
  selector: 'pv-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input() injectClass: string;
  @Input() header: string;
  @Input() contacts: PersonDTO[];

  constructor() { }

  ngOnInit() {
  }

}
